import type {
  ApiError,
  Result,
  ResultService,
  ResultServiceGetInfoParams,
} from '@empathyco/playboard-core-domain'
import type { Ref } from 'vue'
import { ref } from 'vue'
import { CONTAINER } from '../config'
import { TYPES } from '../config/inversify.types'

interface ResultInfoParams {
  loading: Ref<boolean>
  data: Ref<unknown>
  error: any
  fetch: (params: ResultServiceGetInfoParams) => Promise<void>
}

export function useResultInfo(): ResultInfoParams {
  const service = CONTAINER.get<ResultService>(TYPES.ResultService)

  const loading = ref(false)

  const data = ref<Result['info'] | undefined>()

  const error = ref<ApiError | undefined>()

  async function fetch(params: ResultServiceGetInfoParams) {
    loading.value = true
    try {
      const response = await service.getInfo!(params)
      data.value = response?.info
      error.value = undefined
    } catch (e) {
      data.value = undefined
      error.value = e as ApiError
    } finally {
      loading.value = false
    }
  }

  return {
    loading,
    data,
    error,
    fetch,
  }
}
